var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32.5 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main lighter",
    vectorEffect: "non-scaling-stroke",
    d: "M20.4 53.8v12.6s9.9 1.5 9.9-6.6c0 .1-.3-7.7-9.9-6zM2.2 53.4h10.5L2.2 66.3h10.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZd);
export default __webpack_public_path__ + "static/media/ZD.b6c05f13de4e2e476a858b46bc77b04d.svg";
export { ForwardRef as ReactComponent };